import { CbBankFieldTypes, cbBankFields } from 'cbbank/inquiry/fields';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import {
  customValidations,
  fieldValidators,
} from 'modules/Inquiry/inquiryFieldValidation/customValidations';
import { validateFieldValidationMap, ValidateSectionFunction } from 'new/form/useValidateFields';

export const validateUserDataSection: ValidateSectionFunction<InquiryType.cbBank> = (
  form,
  values,
  store,
  conditions,
) => {
  return validateFieldValidationMap<InquiryType.cbBank>({
    validationMap: userDataSectionValidationMap,
    form,
    values,
    conditions,
  });
};

const {
  personalDataPage: {
    userDataSection: { salutation, firstName, lastName, email, phoneNumber },
  },
} = cbBankFields;

export const userDataSectionValidationMap = {
  [salutation]: fieldValidators.string().required(),
  [firstName]: fieldValidators.name().required().isValidName(),
  [lastName]: fieldValidators.name().required().isValidName(),
  [email]: customValidations.newIsEmail<CbBankFieldTypes>,
  [phoneNumber]: fieldValidators.phoneNumber().isMobilePhoneNumber().required(),
};
